import React, { useState } from "react";
import { Link } from "gatsby";

const Tabs = ({ data, keyword }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabIdToSectionId = {
    1: "travel_1",
    2: "travel_2",
    3: "airport_1",
    4: "airport_2",
    5: "stayinformed-section",
  };

  const handleTabClick = (tab, index) => {
    setActiveTab(index);

    const id =
      keyword === "ebola-advisory" ? tab?.tab_id : tabIdToSectionId[tab.tab_id];
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      element.setAttribute("tabindex", "-1");
      element.focus();
    }
  };

  return (
    <div
      className={`${
        data?.length <= 5 ? "xl:w-[70%] mx-auto lg:px-0 px-[2vw]" : "container"
      } lg:flex-wrap lg:justify-center flex-nowrap flex gap-[4vw] xl:gap-[1vw] px-[0.1vw] py-[4vw] xl:py-[2vw] overflow-x-auto whitespace-nowrap custom-scrollbar`}
    >
      {data?.map((tab, index) => (
        <button
          key={index}
          type="button"
          aria-label={`Go to ${tab.tab_name} section`}
          aria-controls={tabIdToSectionId[tab.tab_id]}
          onClick={() => handleTabClick(tab, index)}
          className={`
            ${
              index === activeTab
                ? "bg-[#002C62] text-[#F2F4F7]"
                : "bg-[#FDD7B4] text-[#001836]"
            }
            font-redhatMedium
            lg:text-[1.2vw] text-[3.5vw]
            cursor-pointer
            flex items-center
            lg:px-[1.5vw] px-[5vw]
            lg:py-[0.5vw] py-[2vw]
            lg:rounded-[0.5vw] rounded-[1vw]
            focus:outline focus:outline-2 focus:outline-[#1D4ED8]
          `}
        >
          {tab.tab_name}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
